import { Box, Chip, Container, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import PackageCard from "../../components/cards/PackageCard";
import Grid from "@mui/material/Grid2";
import ProductCardSkeleton from "../../components/skeletons/ProductCardSkeleton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";

const Packages = () => {
  const navigate = useNavigate();
  const { isLoading, data, error } = useSelector(
    (state) => state.packageReducer
  );

  return (
    <Box component={"section"}>
      <Container maxWidth={"lg"} sx={{ mt: 0 }}>
        {data?.length > 0 && isLoading === false && (
          <Stack
            direction={"row"}
            flexWrap={"wrap"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Typography
              variant="h5"
              fontWeight={500}
              textTransform={"capitalize"}
            >
              {t("customPackages")}
            </Typography>

            <Chip
              icon={<VisibilityIcon />}
              label={t("viewAll")}
              size="small"
              color="primary"
              onClick={() => navigate("/custom-packages")}
            />
          </Stack>
        )}

        {/* {isLoading === false && data?.length === 0 && (
          <Typography variant="h4" fontWeight={600} textAlign={"center"}>
            No Product Found !!
          </Typography>
        )} */}

        <Grid container spacing={2} mt={2}>
          {isLoading
            ? Array.from({ length: 8 }).map((_, index) => (
                <Grid key={index} size={{ xs: 6, sm: 4, md: 2.4 }}>
                  <ProductCardSkeleton />
                </Grid>
              ))
            : data?.map((item, index) => (
                <Grid key={index} size={{ xs: 6, sm: 4, md: 2.4 }}>
                  <PackageCard cardData={item} colorName={"text.black"} />
                </Grid>
              ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Packages;
